import { createAnalyticsStore } from "@/store/Analytic/create-chart-store";

export const useImportanceStatBlocksStore = createAnalyticsStore(
  "importanceStatBlocksStore",
  "Analytics/blocks/importance/by_day_of_week/:projectId",
  {
    loadStatType: "withBody",
    crudOptions: { someOption: true } // если нужен пятый параметр для Crud
  }
);